import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/site";

// One shared request; no second frontend taxonomy or category inference.
let cached = null;
let pending = null;
const fetchCategories = () => {
  if (cached) return Promise.resolve(cached);
  if (!pending) pending = axios.get(`${API}/shop-categories`).then(({ data }) => {
    cached = data;
    return data;
  }).finally(() => { pending = null; });
  return pending;
};

export function useShopCategories() {
  const [taxonomy, setTaxonomy] = useState(cached);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setError(false);
    fetchCategories().then(data => { if (active) setTaxonomy(data); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [attempt]);
  return { taxonomy, error, retry: () => setAttempt(n => n + 1) };
}

export function locationPaths(taxonomy, ids = []) {
  const locations = (taxonomy?.groups || []).flatMap(group => group.children.map(child => ({ ...child, group })));
  return ids.map(id => locations.find(location => location.id === id)).filter(Boolean);
}